import { ShippingPartner, WarehouseInfo } from "../types/modalDeliveryTypes";

export const DEFAULT_SHIPPING_PARTNERS: ShippingPartner[] = [
  {
    id: 1,
    name: "NV điều vận",
    description: "Nội bộ Hacom",
    fee: 0,
    estimatedTime: "Không xác định",
    estimatedTimeNumber: 0,
  },
  {
    id: 2,
    name: "Kỹ thuật",
    description: "Nội bộ Hacom",
    fee: 0,
    estimatedTime: "Không xác định",
    estimatedTimeNumber: 0,
  },
  {
    id: 3,
    name: "Dự án",
    description: "Nội bộ Hacom",
    fee: 0,
    estimatedTime: "Không xác định",
    estimatedTimeNumber: 0,
  },
  {
    id: 4,
    name: "Kỹ thuật thi công",
    description: "Nội bộ Hacom",
    fee: 0,
    estimatedTime: "Không xác định",
    estimatedTimeNumber: 0,
  },
  {
    id: 5,
    name: "Giao hàng tiết kiệm",
    description: "Đối tác giao hàng",
    fee: 25000,
    estimatedTime: "2 giờ",
    estimatedTimeNumber: 2,
    isDisabled: false, // Mặc định khả dụng
    errorMessage: null,
  },
  {
    id: 6,
    name: "Ahamove",
    description: "Siêu tốc",
    fee: 35000,
    estimatedTime: "1 giờ",
    estimatedTimeNumber: 1,
    isDisabled: false, // Mặc định khả dụng
    errorMessage: null,
  },
  {
    id: 7,
    name: "Ahamove",
    description: "Siêu tốc tiết kiệm",
    fee: 30000,
    estimatedTime: "2 giờ",
    estimatedTimeNumber: 2,
    isDisabled: false, // Mặc định khả dụng
    errorMessage: null,
  },
];

export const SHIPPING_TYPE_OPTIONS = [
  { value: "Nội bộ Hacom", label: "Nội bộ Hacom" },
  { value: "Siêu tốc", label: "Siêu tốc" },
  { value: "Siêu tốc tiết kiệm", label: "Siêu tốc tiết kiệm" },
  { value: "Đồng giá 25k", label: "Đồng giá 25k" },
  { value: "Đối tác giao hàng", label: "Đối tác giao hàng" },
];

export const WAREHOUSE_DATA: WarehouseInfo[] = [
  {
    id: 488,
    pick_address: "Số 131 Lê Thanh Nghị , Đồng Tâm , Hai Bà Trưng , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hai Bà Trưng",
    pick_ward: "Đồng Tâm",
    pick_tel: "0988655130",
  },
  {
    id: 489,
    pick_address: "Số 284 Thái Hà ,Trung Liệt, Đống Đa , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Đống Đa",
    pick_ward: "Trung Liệt",
    pick_tel: "0988655130",
  },
  {
    id: 491,
    pick_address: "Số 79 Nguyễn Văn Huyên , Quan Hoa , Cầu Giấy , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Cầu Giấy",
    pick_ward: "Quan Hoa",
    pick_tel: "0988655130",
  },
  {
    id: 492,
    pick_address: "Số 313 Quang Trung ,Phú La, Hà Đông , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hà Đông",
    pick_ward: "Phú La",
    pick_tel: "0988655130",
  },
  {
    id: 494,
    pick_address: "Số 622 Nguyễn Văn Cừ ,Gia Thụy , Long Biên , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Long Biên",
    pick_ward: "Gia Thụy",
    pick_tel: "0988655130",
  },
  {
    id: 496,
    pick_address: "62 Nguyễn Hữu Thọ, Hoàng Liệt, Hoàng Mai, Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hoàng Mai",
    pick_ward: "Đại Kim",
    pick_tel: "0988655130",
  },
  {
    id: 221,
    pick_address: "Số 57 Trần Phú ,Văn Quán, Hà Đông , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hà Đông",
    pick_ward: "Văn Quán",
    pick_tel: "0988655130",
  },
  {
    id: 2701,
    pick_address: "Số 805 Giải Phóng ,Giáp Bát, Hoàng Mai , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hoàng Mai",
    pick_ward: "Giáp Bát",
    pick_tel: "0988655130",
  },
  {
    id: 2721,
    pick_address:
      "Số 43 Louis 8 , Hoàng Mai, Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hoàng Mai",
    pick_ward: "Yên Sở",
    pick_tel: "0988655130",
  },
  {
    id: 493,
    pick_address: "Số 478 Cách Mạng Tháng Tám, Quận 3, Hồ Chí Minh",
    pick_province: "Thành phố Hồ Chí Minh",
    pick_district: "Quận 3",
    pick_ward: "Phường 11",
    pick_tel: "0931435431",
  },
  {
    id: 2781,
    pick_address: "34 Trần Não, Phường An Khánh, Hồ Chí Minh",
    pick_province: "Hồ Chí Minh",
    pick_district: "Thủ Đức",
    pick_ward: "Phường An Khánh",
    pick_tel: "0901391682",
  },
  {
    id: 2782,
    pick_address: "783 Phan Văn Trị, Phường Hạnh Thông, Hồ Chí Minh",
    pick_province: "Hồ Chí Minh",
    pick_district: "Quận Gò Vấp",
    pick_ward: "Phường 1",
    pick_tel: "0908971358",
  },
  {
    id: 2741,
    pick_address: "Số 87 Trần Duy Hưng - Yên Hoà - Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Cầu Giấy",
    pick_ward: "Yên Hoà",
    pick_tel: "0988655130",
  },
  {
    id: 124,
    pick_address: "124 Minh Khai, Hai Bà Trưng, Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hai Bà Trưng",
    pick_ward: "Minh Khai",
    pick_tel: "0988655130",
  },
];

export const GHTK_CONFIG = {
  defaultWeight: "1000",
  defaultValue: 100000,
  deliveryOption: "none",
};

export const SHIPPING_LIMITATIONS = {
  "Siêu tốc": {
    maxWeight: 30,
    maxDimension: 60,
    name: "Ahamove Siêu tốc",
  },
  "Siêu tốc tiết kiệm": {
    maxWeight: 30,
    maxDimension: 60,
    name: "Ahamove Siêu tốc tiết kiệm",
  },
  GHTK: {
    maxWeight: 20,
    maxDimension: 60,
    name: "Giao hàng tiết kiệm",
  },
} as const;

export const COD_LIMITS = {
  GHTK: 20000000,
  AHAMOVE_SIEU_TOC: 10000000,
  AHAMOVE_TIET_KIEM: 10000000,
  AHAMOVE_DONG_GIA: 1000000,
};

// Danh sách phường nội thành Hà Nội được miễn phí ship
export const HANOI_FREE_SHIP_WARDS: Array<{ id: string; name: string }> = [
  { id: "3763", name: "Phường Hoàn Kiếm" },
  { id: "5795", name: "Phường Cửa Nam" },
  { id: "5019", name: "Phường Hồng Hà" },
  { id: "4590", name: "Phường Ba Đình" },
  { id: "4162", name: "Phường Ngọc Hà" },
  { id: "3764", name: "Phường Giảng Võ" },
  { id: "5018", name: "Phường Hai Bà Trưng" },
  { id: "5405", name: "Phường Bạch Mai" },
  { id: "5796", name: "Phường Vĩnh Tuy" },
  { id: "4591", name: "Phường Đống Đa" },
  { id: "5406", name: "Phường Văn Miếu - Quốc Tử Giám" },
  { id: "5407", name: "Phường Ô Chợ Dừa" },
  { id: "4163", name: "Phường Kim Liên" },
  { id: "3765", name: "Phường Láng" },
  { id: "5408", name: "Phường Thanh Xuân" },
  { id: "5798", name: "Phường Khương Đình" },
  { id: "3345", name: "Phường Phương Liệt" },
  { id: "4167", name: "Phường Cầu Giấy" },
  { id: "5021", name: "Phường Nghĩa Đô" },
  { id: "4168", name: "Phường Yên Hoà" },
  { id: "4169", name: "Phường Tây Hồ" },
  { id: "6240", name: "Phường Phú Thượng" },
];

// Danh sách phường nội thành TP.HCM được miễn phí ship
export const HCM_FREE_SHIP_WARDS: Array<{ id: string; name: string }> = [
  { id: "6164", name: "Phường Sài Gòn" },
  { id: "4949", name: "Phường Cầu Ông Lãnh" },
  { id: "4528", name: "Phường Bến Thành" },
  { id: "5752", name: "Phường Tân Định" },
  { id: "6167", name: "Phường Hoà Hưng" },
  { id: "6165", name: "Phường Tân Hưng" },
  { id: "4103", name: "Phường Vườn Lài" },
  { id: "6166", name: "Phường Diên Hồng" },
  { id: "3691", name: "Phường Phú Thọ" },
  { id: "4104", name: "Phường Hoà Bình" },
  { id: "6598", name: "Phường Minh Phụng" },
  { id: "6599", name: "Phường Bình Thới" },
  { id: "3688", name: "Phường Xuân Hoà" },
  { id: "3689", name: "Phường Nhiêu Lộc" },
  { id: "5344", name: "Phường Bàn Cờ" },
  { id: "4099", name: "Phường Xóm Chiếu" },
  { id: "5753", name: "Phường Khánh Hội" },
  { id: "4950", name: "Phường Vĩnh Hội" },
  { id: "6596", name: "Phường Chợ Quán" },
  { id: "5754", name: "Phường Chợ Lớn" },
  { id: "6597", name: "Phường An Đông" },
  { id: "5755", name: "Phường Bình Phú" },
  { id: "5345", name: "Phường Bình Tây" },
  { id: "4100", name: "Phường Phú Lâm" },
  { id: "5346", name: "Phường Bình Tiên" },
  { id: "4101", name: "Phường Tân Mỹ" },
  { id: "5756", name: "Phường Tân Thuận" },
  { id: "5347", name: "Phường Phú Thuận" },
  { id: "4102", name: "Phường Phú Định" },
  { id: "4529", name: "Phường Chánh Hưng" },
  { id: "3690", name: "Phường Bình Đông" },
  { id: "4951", name: "Phường Trung Mỹ Tây" }, // Thạnh Mỹ Tây
  { id: "3694", name: "Phường Gia Định" },
  { id: "3695", name: "Phường Bình Lợi Trung" },
  { id: "4532", name: "Phường Bình Thạnh" },
  { id: "5349", name: "Phường Hạnh Thông" },
  { id: "6169", name: "Phường Thông Tây Hội" }, // Tây Hội
  { id: "6168", name: "Phường An Nhơn" },
  { id: "4954", name: "Phường Gò Vấp" },
  { id: "3696", name: "Phường An Hội Tây" },
  { id: "5757", name: "Phường An Hội Đông" },
  { id: "4108", name: "Phường Phú Nhuận" },
  { id: "4955", name: "Phường Đức Nhuận" },
  { id: "3697", name: "Phường Cầu Kiệu" },
  { id: "5759", name: "Phường Tân Sơn" },
  { id: "5758", name: "Phường Tân Hoà" },
  { id: "6602", name: "Phường Tân Bình" },
  { id: "4533", name: "Phường Tân Sơn Hoà" },
  { id: "6601", name: "Phường Bảy Hiền" },
  { id: "5350", name: "Phường Tân Sơn Nhất" },
  { id: "5760", name: "Phường Tân Sơn Nhì" },
  { id: "5761", name: "Phường Tân Phú" },
  { id: "4534", name: "Phường Phú Thạnh" },
  { id: "3698", name: "Phường Phú Thọ Hoà" },
  { id: "4956", name: "Phường Tây Thạnh" },
  { id: "5348", name: "Phường Bình Quới" },
];

// Helper function để kiểm tra phường có được miễn phí ship không
export const isFreeShipWard = (wardId: string): boolean => {
  const allFreeShipWards = [
    ...HANOI_FREE_SHIP_WARDS.map((w) => w.id),
    ...HCM_FREE_SHIP_WARDS.map((w) => w.id),
  ];
  return allFreeShipWards.includes(wardId);
};
